import { Link } from 'react-router-dom';
import './SetupAgentPage.css';
import './ViewAgentPage.css';

const RoutingAdminPage = () => {
  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : {};
  const role = user.role || 'STANDARD';
  const isAdmin = role === 'ADMIN';

  const routingAdmin = [
    {
      id: 1,
      title: 'Routing Dashboard',
      description: 'View and manage routing configurations',
      icon: '\uD83D\uDCC9',
      path: '/routing-dashboard',
      color: '#2196f3',
    }, 
    {
      id: 2,
      title: 'Attribute Registry',
      description: 'Manage the attribute registry for routing administration',
      icon: '\uD83D\uDCC8',
      path: '/attribute-registry',
      color: '#4caf50'
    },
    {
        id: 3,
        title: 'Routing Groups',
        description: 'Manage routing groups',
        icon: '\uD83D\uDCCA',
        path: '/routing-groups',
        color: '#ff9800',
    },
    {
        id: 4,
        title: 'Routing Policies',
        description: 'Manage routing policies',
        icon: '\uD83D\uDCCA',
        path: '/routing-policies',
        color: '#ff5722',
    },
    {
        id: 5,
        title: 'Routing Restrictions',
        description: 'Manage routing restrictions',
        icon: '\uD83D\uDCCB',
        path: '/routing-restrictions',
        color: '#9c27b0',
    },
    
    {
        id: 6,
        title: 'Routing Simulation',
        description: 'Simulate routing scenarios',
        icon: '\uD83D\uDCCA',
        path: '/routing-simulation',
        color: '#ff9800',
    }
  ]

  const standardRouting = [
    {
      id: 1,
      title: 'Routing Dashboard',
      description: 'View and manage routing configurations',
      icon: '\uD83D\uDCC9',
      path: '/routing-dashboard',
      color: '#2196f3',
    }, 
  ];
  
  const features = isAdmin ? routingAdmin : standardRouting;

  return (
    <div className="setup-page">
      <div className="page-header">
        <div>
           <h1>Routing Administration</h1>
           <p className="home-subtitle">
            {isAdmin
              ? 'You have administrator access to manage routing policies'
              : 'You have standard access to manage routing policies'}
           </p>
        </div>
        <Link to="/business-admin" className="btn btn-secondary">
          ← Back to Business Administration 
        </Link>
      </div>
     

      <div className="features-grid">
        {features.map((feature) => {
        if (feature.comingSoon) {
            return (
            <div
                key={feature.id}
                className="feature-card feature-card-disabled"
                style={{ '--feature-color': feature.color }}
            >
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <span className="coming-soon-badge">Coming Soon</span>
            </div>
            );
        }
        return (
            <Link
            key={feature.id}
            to={feature.path}
            className="feature-card"
            style={{ '--feature-color': feature.color }}
            >
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
            <span className="feature-arrow">&rarr;</span>
            </Link>
        );
        })}
      </div>
    </div>           
  );
};

export default RoutingAdminPage;